var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarRepair = function SvgCarRepair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#5f6368",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440-80v-120H160v-80h640v80H520v120zm-80-420q17 0 28.5-11.5T400-540t-11.5-28.5T360-580t-28.5 11.5T320-540t11.5 28.5T360-500m240 0q17 0 28.5-11.5T640-540t-11.5-28.5T600-580t-28.5 11.5T560-540t11.5 28.5T600-500M200-616l66-192q5-14 16.5-23t25.5-9h344q14 0 25.5 9t16.5 23l66 192v264q0 14-9 23t-23 9h-16q-14 0-23-9t-9-23v-48H280v48q0 14-9 23t-23 9h-16q-14 0-23-9t-9-23zm106-64h348l-28-80H334zm-26 80v120zm0 120h400v-120H280z"
  })));
};
export default SvgCarRepair;